// Sticky header: fixed bar + in-flow spacer (see global-header.css). No scroll-based theme overrides.
class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.spacer = document.querySelector('[data-header-spacer]');
    this.mainContent = document.getElementById('MainContent');
    this.overlayBodyClasses = ['template-index', 'gift_cards', 'faq', 'template-blog'];
    this.lastScrollTop = 0;
    this.desktopEnabled = this.dataset.stickyDesktop === 'true';
    this.mobileEnabled = this.dataset.stickyMobile === 'true';
    this.isFixed = false;
    this.onScroll = this.onScroll.bind(this);
    this.syncSpacer = this.syncSpacer.bind(this);

    this.resizeObserver = new ResizeObserver(this.syncSpacer);
    this.resizeObserver.observe(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.syncSpacer);

    this.syncSpacer();
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.syncSpacer);

    if (this.mainContent) {
      this.mainContent.style.marginTop = '';
    }
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || document.querySelector('search-modal');
    if (!this.searchModal) return;
    this.searchModal.close(false);
  }

  closeMenuDropdowns() {
    document.querySelectorAll('.dropdown.open').forEach((el) => {
      el.classList.remove('open');
    });
  }

  get useOverlaySpacer() {
    const bodyClass = document.body.className;
    return this.overlayBodyClasses.some((c) => bodyClass.split(/\s+/).includes(c));
  }

  syncSpacer() {
    if (!this.spacer) return;
    const h = this.offsetHeight;

    if (!this.isFixed) {
      this.spacer.style.height = '0px';
      if (this.mainContent) {
        this.mainContent.style.marginTop = '';
      }
      return;
    }

    if (this.useOverlaySpacer) {
      this.spacer.style.height = '0px';
    } else {
      this.spacer.style.height = `${h}px`;
    }

    if (this.mainContent) {
      this.mainContent.style.marginTop = `${h}px`;
    }
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const threshold = 120;

    const isDesktop = window.matchMedia('(min-width: 992px)').matches;
    const stickyAllowed = (isDesktop && this.desktopEnabled) || (!isDesktop && this.mobileEnabled);

    if (!stickyAllowed) {
      if (this.isFixed) {
        this.isFixed = false;
        this.classList.remove('sticky-header--fixed');
        this.syncSpacer();
      }
    } else {
      if (scrollTop > threshold && !this.isFixed) {
        this.isFixed = true;
        this.classList.add('sticky-header--fixed');
        this.syncSpacer();
      } else if (scrollTop <= threshold && this.isFixed) {
        this.isFixed = false;
        this.classList.remove('sticky-header--fixed');
        this.syncSpacer();
      }
    }

    if (scrollTop > this.lastScrollTop && scrollTop > 48) {
      this.closeSearchModal();
      this.closeMenuDropdowns();
    }
    this.lastScrollTop = scrollTop;
  }
}

customElements.define('sticky-header', StickyHeader);
